export const ACTION_IDS = {
	CREATE_TOURNAMENT_REFUND_REQUEST: 'createTournamentRefundRequest'
};

export const ACTION_LABELS = {
	[ACTION_IDS.CREATE_TOURNAMENT_REFUND_REQUEST]: 'Create Refund Request'
};

export const BUTTON_LABELS = {
	AGREE: 'Submit',
	DISAGREE: 'Cancel'
};
